export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
  AGEN = 'AGEN',
  RESERVATION_ADMIN = 'RESERVATION_ADMIN',
  RESERVATION_AGENT = 'RESERVATION_AGENT'
}
export enum Provider {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
  LOCAL = 'LOCAL'
}

export enum ReservationStatus {
  NEED_APPROVAL = 0,
  APPROVED = 1,
  ARRIVED = 2,
  ON_ACTIVITY = 3,
  ENDED = 4,
  RESCHEDULED = 5,
  PAID = 6,
  CANCELED = 9
}

export enum AgentType {
  AGENT = 1,
  FREELANCE = 2,
  RESERVATION = 3
}

export enum ReservationAdminType {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  FRONT_OFFICE = 3,
  ATV_PIC = 4,
  RAFTING_PIC = 5,
  TRANSPORTATION_PIC = 6,
  FINANCE = 7,
  FINANCE_LITE = 8,
  RESERVATION = 9
}

export enum PaymentType {
  CASH = 1,
  CARD = 2,
  TRANSFER = 3,
  VCR = 4,
  DEPOSIT = 5,
  PAYMENT_ON_ARRIVAL = 6
}

export interface AuthUser {
  id: number
  uuid?: string
  first_name: string
  last_name: string
  name: string
  birth_date: string | null
  profile_picture: string | null
  email: string
  is_active: 0 | 1
  phone: string | null
  username: string | null
  country?: string | null
  city?: string | null
  is_able_without_payment?: 0 | 1
  identity_picture: string | null
  is_first_login?: boolean | number
  balance?: number
  points?: number
  is_ar?: boolean
  type?: number
}

export interface AuthLogin {
  email: string | undefined
  password: string | undefined
  remember_me?: boolean | number
}

export interface AuthRegister {
  first_name: string
  last_name: string
  email: string
  phoner: string
  password: string
  comfirm_password: string
}

export interface AuthCredential {
  token: AuthToken
  provider: AuthProvider
  role: AuthRole
}

export interface ErrorObject {
  [key: string]: string[]
}

export interface ResponseErrorObject {
  message: string
  errors?: ErrorObject
}

/**
 * @see https://vee-validate.logaretm.com/v4/tutorials/dynamic-form-generator/
 */
interface FormDynamicItem {
  label?: string
  name: string
  as: string
  rules?: any
  class?: string
}
export interface FormDynamic {
  fields: FormDynamicItem[]
}

export type AuthToken = string
export type AuthRole = Role
export type AuthProvider = Provider
export type IsLogin = boolean

export interface Variant {
  id?: number | string
  product_id?: string | number
  name: string
  description?: string
  id_description?: string
  duration?: string
  price: string
  usd_price: string
  nett_price: string
  price_value: string
  /**
   * used for agent only
   */
  special_agent_price?: string
  quantity?: number
  max_order?: number
  min_order?: number
  category: 'single' | 'tandem'
  person_qty?: number
  available_times?: string[]
  person?: Person[]
  is_product_it_self?: 0 | 1
  activity_title?: string | undefined
  images?: ImageCategory[]
}

export interface PriceList {
  uuid: string
  package_name: string
  name: string
  description: string
  price_list: Variant[]
}

export interface Addons {
  id: string | number
  name: string
  description: string
  id_description: string
  usd_price: number | string | undefined
  price?: number | string | undefined
  nett_price?: string
  quantity?: number
  product_id?: string | number
}

export interface AdditionalAddons {
  id: number | string
  name: string
  slug: string
  description: string
  id_description: string
  price: number | string | undefined
  usd_price: number | string | undefined
  price_value: string
  is_saleable: 0 | 1
  is_qty_limited: 0 | 1
  available_times?: string[] | null
  deleted_at?: string
  created_at?: string
  updated_at?: string
}
export interface AddonsAPI {
  id: number | string
  product_id: number | string
  variant_id: string | null
  additional_id: number | string
  created_at?: string
  updated_at?: string
  quantity?: number
  additional: AdditionalAddons
}

export interface ATV_FORM {
  product_id: number | undefined
  name: string | undefined
  variant_name?: string | undefined
  variant: Variant[]
  addOns: Addons[]
  total_dollar?: string | number | undefined
  total_rupiah?: string | number | undefined
}

export interface DirtyFormOrder {
  product_id: number | undefined
  name: string | undefined
  variant_name?: string | undefined
  variant: Variant[]
  addOns: Addons[]
  total_dollar?: string | number | undefined
  total_rupiah?: string | number | undefined
  activity_date: string
  arrival_time: string
  guest_first_name?: string
  guest_last_name?: string
  guest_email?: string
  guest_mobile_number?: string
}

export interface Person {
  product_id: number | string | undefined
  variant_id: number | string | undefined
  id?: number | string | undefined
  is_pic: boolean
  name: string | undefined
  birth_date: string
  nationality: string | undefined
  age: number | undefined
  email?: string | undefined
  phone?: string | undefined
  is_completed: boolean
}

export interface bookingProperty {
  activity_date: string
  arrival_time: string | undefined
}

export interface ImageCategory {
  id: number
  position: number
  image: string
}

export interface CategoryItineraryItem {
  time: string
  title: string
  description: string
}

export interface CategoryDropdownSection {
  title: string
  description: string
}

export interface CategoryProduct {
  id: number
  slug: string
  name: string
  images: ImageCategory[]
  full_description?: string
  short_description: string
  id_full_description?: string
  id_short_description?: string
  itinerary?: CategoryItineraryItem[]
  dropdowns?: CategoryDropdownSection[]
  created_at: string
  updated_at: string
  products?: Product[]
}

export interface CategoryBlog {
  id: number
  slug: string
  title: string
  short_description: string
  body: string
  category: string
  meta: string
  total_view: number
  image: string
  created_at: string
  updated_at: string
}

export interface GeneralResponse<T> {
  message: string
  data: T
}

export interface AddOnsDetail {
  id: number
  product_id: number
  variant_id: number
  additional: AdditionalAddons
}

export interface Product {
  id?: number
  name: string
  slug: string
  package_name: string
  description: string
  id_description: string
  price: number | string | undefined
  usd_price: number | string | undefined
  nett_price: number | string
  price_value: string
  max_order: number | string | undefined
  min_order: 1
  is_saleable: 0 | 1
  category_id: number
  person_qty: number
  is_varied: 0 | 1
  available_times?: string[]
  average_rating: number
  created_at?: string
  updated_at?: string
  variants?: Variant[]
  special_agent_price?: number | string | undefined
  additionals?: AddOnsDetail[]
  images?: ImageCategory[]
  activity_hours: string
  location: string
  booking_method: string
  category: CategoryProduct
}

export interface ItemProductOrder {
  id: number | string
  variant_id: number | string
  quantity: number
}

export interface ItemAdditionalOrder {
  /**
   * helper to know who load the additional
   */
  product_id: number | string | undefined
  id: string | number
  quantity: string | number
}

export interface ItemFormOrder {
  product_id: string | number
  variant_id: string | number
  name: string | undefined
  age: number | undefined
  email: string | undefined
  phone: string | undefined
  is_pic: 0 | 1
  birth_date: string | null
  nationality: string
}

export interface OrderProduct {
  products: ItemProductOrder[]
  additionals: ItemAdditionalOrder[]
  forms: ItemFormOrder[]
  activity_date: string | undefined
  arrival_time: string | undefined
}

export interface ProductThumbnail {
  id: number
  name: string
  image: string
  created_at: string
}

export interface Purchase {
  id: number
  uuid: string
  grand_total_purchased: string
  grand_total_usd_purchased: string
  status: string
  other_products: number
  product_thumbnail: ProductThumbnail
  activity_date?: string
  arrival_time?: string
  created_at: string
  updated_at: string
}

interface LinksAPI {
  first: string
  last: string
  prev: string | null
  next: string | null
}

export interface Link {
  url?: string
  label: string
  active: boolean
}

interface MetaAPI {
  current_page: number
  from: number
  last_page: number
  links: Link[]
  path: string
  per_page: number
  to: number
  total: number
}

export interface ResponseData<T> {
  data: T
  links: LinksAPI
  meta: MetaAPI
}

export interface ProductDetails {
  id: number
  name: string
  cart_id: number
  package_name: string
  product_id: number
  product_slug: string
  variant_id: number
  description: string
  id_description: string
  quantity: string
  price: string
  nett_price: string
  usd_price: string
  total_price: string
  total_usd_price: string
  image: string
  created_at: string
  is_saleable?: 0 | 1
  is_available?: 0 | 1
}

export interface AdditionalDetails {
  id: number
  product_id: number
  variant_id: number
  additional_id: number
  product_additional_id: number
  card_id: number
  package_name: string
  name: string
  description: string | null
  quantity: string
  available_times?: string[]
  price: string
  usd_price: string
  total_price: string
  total_usd_price: string
  created_at: string
}

export interface FormDetails {
  id: number
  order_id: number
  product_id: number
  variant_id: number
  cart_id: number
  name: string
  age: number
  email: string
  phone: string
  birth_date: string
  nationality: string
  is_pic: number
  activity_date: string | null
  created_at: string
  updated_at: string
  is_completed?: boolean
}

export interface DetailOrders {
  id: number
  uuid: string
  address: string | null
  total_purchased: string
  total_usd_purchased: string
  total_additional_purchased: string
  total_usd_additional_purchased: string
  promo_amount: string
  grand_total_purchased: string
  grand_total_usd_purchased: string
  payment_url: string
  payment_status: string
  refund_status: string | null
  status: string
  details: ProductDetails[]
  additionals: AdditionalDetails[]
  forms: FormDetails[]
  activity_date?: string
  arrival_time?: string
  created_at: string
  updated_at: string
  user?: AuthUser
  user_role?: 'user' | 'agent'
  note?: string | undefined
  guest_email?: string
  guest_first_name?: string
  guest_last_name?: string
  guest_mobile_number?: string
  total_remaining?: string
  is_full_payment?: boolean
  dp_amount?: string
}
export interface Payment {
  order_uuid: string
  payment_url: string
}

export interface Contact {
  id?: number | string
  first_name: string | undefined
  last_name: string | undefined
  email: string | undefined
  phone: string | undefined
  message: string | undefined
  is_replied?: 0 | 1
  created_at?: string
}

export interface EditPerson extends ProductDetails {
  forms: FormDetails[]
}

export interface TimeNotAvailable {
  product_id: number | string
  variant_id: number | string
  times: string[]
}

export interface AdditionalProduct {
  id?: number
  slug?: string | undefined
  name: string | undefined
  price: number | undefined
  description: string | undefined
  id_description: string | undefined
  usd_price: number | undefined
  price_value: string
  is_saleable: 0 | 1
  is_qty_limited: 0 | 1
  available_times?: string[]
  created_at?: string
  updated_at?: string
}

export interface ImageResponse {
  id: number
  image: string
  position: number
  type?:
    | 'image'
    | 'image_2'
    | 'image_3'
    | 'image_4'
    | 'image_5'
    | 'image_6'
    | 'image_7'
    | 'image_8'
    | 'image_9'
    | 'image_10'
}

export interface DASHBOARD {
  total_order: number
  total_order_this_month: number
  total_user: number
  total_agent: number
}

export interface PRODUCT_ORDER_AVAILABLE {
  product_id: number | string
  variant_id?: number | string
  is_avilable: boolean
  times: string[]
}

export interface AGENT_SPECIAL_PRICE {
  id: number
  agent_id: number
  product_id: number
  variant_id: number
  nett_price: string | number
  agent: AuthUser
  product?: Product
  variant?: Variant
}

export interface BlogMetaPagination {
  current_page: number
  from: number
  last_page: number
  path: string
  per_page: number
  to: number
  total: number
  links: []
}

export interface BlogCategory {
  id: number
  created_at: string
  updated_at: string
  name: string
  slug: string
  description: string
}

export interface BlogDetail {
  id: number
  created_at: string
  updated_at: string
  image: string
  image_2: string
  image_3: string
  image_4: string
  image_5: string
  image_6: string
  image_7: string
  image_8: string
  image_9: string
  image_10: string
  short_description: string
  body: string
  slug: string
  title: string
  total_view: number
  category: BlogCategory[]
}

export interface AdminListArticle {
  id: number
  slug: string
  title: string
  short_description: string
  category: string
  meta: string
  total_view: number
  image: string
}

export interface ArticleCategoryData {
  id: number
  slug: string
  name: string
  description: string
  created_at: string
  updated_at: string
}

export interface AdminArticleDetail {
  id: number
  slug: string
  title: string
  short_description: string
  body: string
  meta: string
  total_view: number
  category?: ArticleCategoryData
  image: string
  image_2: string
  image_3: string
  image_4: string
  image_5: string
  image_6: string
  image_7: string
  image_8: string
  image_9: string
  image_10: string
  created_at: string
  updated_at: string
}

export interface ReservationAgent {
  id: number
  uuid?: string
  name: string
  email: string
  phone: string
  birth_date: string
  type: number
  status: boolean
  is_ar: number
  ar: number
  created_at: string
  updated_at: string
}

export interface ReservationAdmin {
  id: number
  uuid?: string
  name: string
  email: string
  type: number
  status: boolean
  created_at: string
  updated_at: string
}

export interface ReservationDriver {
  id: number
  name: string
  phone: string
  created_at: string
  updated_at: string
}

export interface ReservationMembership {
  id: number
  name: string
  membership_number: string
  phone: string
  expiry_date: string
  total_pax?: number
  total_trx?: number
  pending_trx?: number
  total_nett?: number
  pending_nett?: number
  total_commission?: number
  pending_commission?: number
  created_at?: string
  updated_at?: string
}

export interface ReservationGuide {
  id: number
  name: string
  phone: string
  type: number
  type_label: string
  created_at: string
  updated_at: string
}

export interface ReservationAgentList {
  id: number
  name: string
}

export interface ReservationProduct {
  id: number
  slug: string
  name: string
  type: string
  time: string[]
  price: number
  child_price: number
  private_price: number
  private_pax: number
  point: number
  reward: number
  duration: number
  status: number
  photo: string | null
  photo_url: string | null
  available_at?: Array<ReservationAgentList> | string[]
  available_agent_names?: string[]
  is_special: boolean
  is_bundle: boolean
  is_tandem: boolean
  is_private: boolean
  product_1: ReservationProduct
  product_2: ReservationProduct
  product_price_1: number
  product_price_2: number
  image: string
}

export interface ReservationBooking {
  ref: string
  guest_name: string
  guest_phone?: string
  booking_date: string
  raw_booking_date: string
  installment: number
  total_amount: number
  total_discount: number
  deposit: number
  collect: number
  remarks: string
  is_transport: boolean
  transport_pax: number
  transport_price: number
  pickup_address: string
  pickup_time: string
  status: number
  status_label: number
  created_at: string

  payment: ReservationPayment
  details: ReservationBookingDetail[]
}

export interface AdminReservationBooking {
  ref: string
  guest_name: string
  guest_phone?: string
  booking_date: string
  raw_booking_date: string
  installment: number
  total_amount: number
  total_discount: number
  total_markup: number
  total_payment: number
  deposit: number
  collect: number
  cash: number
  card: number
  trf: number
  vcr: number
  remarks: string
  agent_remarks: string
  is_transport: boolean
  transport_price: number
  transport_pax: number
  pickup_address: string
  pickup_time: string
  transport_departure_time: string
  transport_arrival_time: string
  driver: string
  status: number
  status_label: number
  created_at: string
  approved_at: string | null
  arrived_at: string | null
  paid_at: string | null
  canceled_at: string | null

  agent: ReservationAgent
  payment: ReservationPayment
  details: AdminReservationBookingDetail[]
  commission_receiver?: ReservationMembership | null

  is_first_activity: boolean
  booking_activity_count: number
  is_payment_balance?: boolean
}

export interface FinanceReservationBooking {
  ref: string
  guest_name: string
  guest_phone?: string
  booking_date: string
  raw_booking_date: string
  installment: number
  total_amount: number
  total_discount: number
  total_payment: number
  deposit: number
  collect: number
  commission: number
  cash: number
  card: number
  trf: number
  vcr: number
  remarks: string
  agent_remarks: string
  finance_remarks: string
  commission_status: number
  is_transport: boolean
  transport_price: number
  transport_pax: number
  pickup_address: string
  pickup_time: string
  transport_departure_time: string
  transport_arrival_time: string
  driver: string
  status: number
  status_label: number
  created_at: string

  agent: ReservationAgent
  payment: ReservationPayment
  details: AdminReservationBookingDetail[]

  is_first_activity: boolean
  booking_activity_count: number
  is_payment_balance?: boolean
}

export interface ReservationAdminPaymentForm {
  cash: number
  card: number
  vcr: number
  trf: number
}

export interface ReservationAgentDeposit {
  transaction_type: number
  source: string
  category: string
  amount: number
  created_at: string
}

export interface ReservationBookingDetail {
  activity_time: string
  adult_pax: number
  child_pax: number
  is_discount: boolean
  is_markup: boolean
  discount_amount: number
  markup_amount?: number
  /** signed per-pax, receipt only: positive marks up, negative marks down */
  deal_price_delta?: number
  total_price: number

  product: ReservationProduct
}

export interface AdminReservationBookingDetail {
  id: number
  activity_time: string
  adult_pax: number
  child_pax: number
  atv_unit: number
  guide: string
  start_time: string
  end_time: string
  remarks: string
  status: number
  status_label: number
  is_discount: boolean
  is_markup: boolean
  discount_amount: number
  markup_amount?: number
  /** signed per-pax, receipt only: positive marks up, negative marks down */
  deal_price_delta?: number
  total_price: number
  is_bundle: boolean
  reservation_bundle_id: number | null
  bundle_type: string | null
  bundle_name: string | null
  bundle_price: number | null

  product: ReservationProduct
}

export interface FinanceReservationBookingDetail {
  id: number
  activity_time: string
  adult_pax: number
  child_pax: number
  guide: string
  start_time: string
  end_time: string
  remarks: string
  status: number
  status_label: number
  is_discount: boolean
  is_markup: boolean
  discount_amount: number
  markup_amount?: number
  /** signed per-pax, receipt only: positive marks up, negative marks down */
  deal_price_delta?: number
  total_price: number
  is_bundle: boolean
  reservation_bundle_id: number | null
  bundle_type: string | null
  bundle_name: string | null
  bundle_price: number | null

  product: ReservationProduct
  bundle: ReservationProduct
}

export interface AdminReservationBookingSummary {
  total_booking_count_daily: number
  total_trx_amount_daily: number
  total_nett_amount_daily: number
  total_pax_amount_daily: number
  total_commission_daily: number
  commission_per_activity: {
    activity_category: string
    total_commission: number
  }[]
  pax_per_product_type: {
    product_type_name: string
    total_pax: number
  }[]
  total_nett_plus_commission: number
  total_cash_daily: number
  total_card_daily: number
  total_trf_daily: number
  total_vcr_daily: number
  total_deposit_daily: number
}

export interface ReservationProductType {
  id: number
  name: string
  status: number
}

export interface ReservationProductMapping {
  id: number
  product_name: string
  reservation_product_name: string
}

export interface ReservationAdditionalMapping {
  id: number
  additional_name: string
  reservation_product_name: string
}

export interface ReservationAgentPayment {
  id: number
  bank: string
  account_holder: string
  account_number: string
  status: number
}

export interface ReservationPayment {
  id: number
  name: string
  details: string
  installment: number[]
  is_installment: number
  is_deposit: number
  payment_type: string
}

export interface ReservationDepositRequest {
  reservation_agent_payment_id: number
  reservation_payment_id: number
  nominal: number
}

export interface ReservationWithdrawRequest {
  reservation_agent_payment_id: number
  nominal: number
}

export interface ReservationDepositRequestList {
  id: number
  agent: ReservationAgent
  payment: ReservationPayment
  agent_payment: ReservationAgentPayment
  status: number
  nominal: number
  created_at: string
}

export interface ReservationWithdrawRequestList {
  id: number
  agent: ReservationAgent
  agent_payment: ReservationAgentPayment
  status: number
  nominal: number
  created_at: string
}

export interface ReservationBookingForm {
  guest_name: string
  booking_date: string
  reservation_payment_id: number
  reservation_agent_id?: number
  reservation_agent_name?: string
  commission_receiver_id?: number
  commission_receiver_name?: string
  installment?: number
  total_amount?: number
  deposit?: number
  collect?: number
  remarks?: string

  booking_details: ReservationBookingDetailForm[]
  booking_addons: ReservationBookingAddonForm[]
  transport: ReservationBookingTransportForm
  collect_enabled?: boolean
  deposit_enabled?: boolean
}

export interface ReservationBookingTransportForm {
  is_transport: boolean
  quantity: number
  price: number
  area: string
  address: string
}

export interface ReservationBookingDetailForm {
  reservation_product_id: number
  activity_name: string
  activity_time: string[]
  time: string
  time_2?: string
  adult_pax: number
  child_pax: number
  total_pax: number
  adult_price: number
  child_price: number
  total_price: number
  point?: number
  total_point?: number
  duration: number
  discount_amount?: number
  is_discount?: boolean
  markup_amount?: number
  is_markup?: boolean
  /** signed per-pax, receipt only: positive marks up, negative marks down */
  deal_price_delta?: number
  is_point?: boolean
  is_private?: boolean
  is_tandem?: boolean
  private_price?: number
  private_pax?: number
  is_bundle?: boolean
  product_1?: ReservationProduct
  product_2?: ReservationProduct
  activity_time_1?: string[]
  activity_time_2?: string[]
}

export interface ReservationBookingAddonForm {
  reservation_addon_id: number
  quantity: number
  remarks?: string
}

export interface ReservationAddon {
  id: number
  name: string
  description: string
  price?: number
  is_transport: number
  transport_mapping?: ReservationTransportMapping[]
  created_at: string
  updated_at: string
}

export interface ReservationTransportMapping {
  destination: string
  price: number
}
